import React, { useCallback, useMemo, useState, useRef, useEffect } from 'react'

import { Report } from '~/components';
import {
  RadioGroup
} from '~/components/Form';

import { Autocomplete, Select, Input, Checkbox } from '~/components/Form'
import { format, subDays, setHours, setMinutes, setSeconds } from 'date-fns';
import { SelectComplete } from '~/componentslocal';
import * as Yup from 'yup';
import { t, parseDateString } from '~/helpers';

import { TypeFilters } from '~/components';


export default function DlgRelAbastecimento() {

  const filterRef = useRef(null);

  const [open, setOpen] = useState(true);
  const reference = useRef(null);
  const [dataObjto, setDataObjto] = useState({});
  const [post, setPost] = useState('')
  const [clearPost, setClearPost] = useState(false)

  const [tipoTypeFilters, setTipoTypeFilters] = useState(0)

  const [dataHoraInicial, setDataHoraInicial] = useState('')
  const [dataHoraFinal, setDataHoraFinal] = useState('')

  const [ambiente, setAmbiente] = useState(true)
  const [somente20graus, setSomente20Graus] = useState(false)


  const schemaDataHora = Yup.object().shape({
    datahora_inicio: Yup.date()
      .typeError(t('s.geral.validacao.campoobrigatorio'))
      .transform((_, value) => parseDateString(value))
      .required(t('s.geral.validacao.campoobrigatorio')),
    datahora_fim: Yup.date()
      .typeError(t('s.geral.validacao.campoobrigatorio'))
      .transform((_, value) => parseDateString(value))
      .required(t('s.geral.validacao.campoobrigatorio'))
  });

  const schemaOnlyDataTurno = Yup.object().shape({
    data_inicio_turno: Yup.date()
      .typeError('Data inválida')
      .transform((_, value) => parseDateString(value))
      .required(t('s.geral.validacao.campoobrigatorio')),
    data_fim_turno: Yup.date()
      .typeError('Data inválida')
      .transform((_, value) => parseDateString(value))
      .required(t('s.geral.validacao.campoobrigatorio')),
  });

  const validPosto = Yup.object().shape({
    post_cod_posto: Yup.string().typeError(t('s.geral.validacao.campoobrigatorio')).required(t('s.geral.validacao.campoobrigatorio'))
  });



  const handleValidate = useCallback(async (data) => {
    try {
      if (tipoTypeFilters == 1) {
        await schemaDataHora.validate({ datahora_inicio: dataHoraInicial, datahora_fim: dataHoraFinal }, {
          abortEarly: false,
        });
      } else if (tipoTypeFilters == 5) {
        await schemaOnlyDataTurno.concat(validPosto).validate({ data_inicio_turno: dataHoraInicial, data_fim_turno: dataHoraFinal, post_cod_posto: post.post_cod_posto }, {
          abortEarly: false,
        });
      }
      filterRef.current.setErrors({})
    } catch (err) {
      const form = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          form[error.path] = error.message.replace(`${error.path} `, '');
        });
        filterRef.current.setErrors(form);

      }
      throw err
    }
  }, [dataObjto, dataHoraInicial, dataHoraFinal, filterRef, tipoTypeFilters, post])

  const handleGetData = useCallback((value) => {
    setTipoTypeFilters(value.tipo)
    if (value.tipo === 1) {
      setDataHoraInicial(value.datahora_inicio)
      setDataHoraFinal(value.datahora_fim)
    } else if (value.tipo == 5) {

      setDataHoraInicial(value.turno_inicio ? value.turno_inicio.turn_datahora_ini : value.data_inicio_turno + ' 00:00:00')
      setDataHoraFinal(value.turno_fim ? value.turno_fim.turn_datahora_fim : value.data_fim_turno + ' 23:59:59')

    } else if (value.tipo == 2) {
      setDataHoraInicial(value.data_inicio + ' 00:00:00')
      setDataHoraFinal(value.data_fim + ' 23:59:59')
    }
    setDataObjto(value);
  }, [filterRef]);

  const handleSerializeForm = useCallback((param) => {
    return {
      ...param,
      ambiente: ambiente,
      somente20graus: somente20graus,
      post_cod_posto: post.post_cod_posto ? post.post_cod_posto : '',
      posto_str: post.post_desc ? post.post_desc : '',
      turn_datahora_ini: dataHoraInicial,
      turn_datahora_fim: dataHoraFinal,
      corredor: param.corredor ?? 'todos',
      bico: param.bico ?? '',
      veiculo: param.veiculo ?? '',
      maquinista: param.maquinista ?? '',
      mostraoperador: '',
      totalizar: param.totalizar ? true : false,
      overfill: param.overfill ? "1" : "0",
      turn_num_turn_ini: 0,
      turn_num_turn_fim: 0,
      ordenacao: param.ordenacao ?? 'listagem',
      ordenacao_desc: param.ordenacao ?? 'listagem',
      ident: param.ident ?? 'todos',
      idtarefapath: "dlgRelAbastecimento.swf"
    }

  }, [dataHoraInicial, dataHoraFinal, post, ambiente, somente20graus])

  return (
    <Report
      ref={reference}
      open={open}
      onClose={() => setOpen(false)}
      title="RELATÓRIO DE ABASTECIMENTOS"
      relatorio="ABASTECIMENTO"
      validate={handleValidate}
      serialize={(param) => handleSerializeForm(param)}
    >
      <RadioGroup
        name="tipo_posto"
        label="Tipo:"
        options={[
          { label: 'Ambiente', value: 'amb' },
          { label: '20°', value: '20' },
        ]}
        defaultValue="amb"
        getValue={(value) => {
          setClearPost(true)
          if (value == 'amb') {
            setAmbiente(true)
            setSomente20Graus(false)
          } else {
            setAmbiente(false)
            setSomente20Graus(true)
          }
        }}
        serialize={(value) => value}
        row
      />

      <SelectComplete
        name="post_cod_posto"
        title="Posto"
        label="post_desc"
        unique="post_cod_posto"
        hiddens={[{ name: 'post_desc' }]}
        url="usuarioposto"
        getValue={(value) => {
          setClearPost(false)
          setPost(value)
        }}
        clearField={clearPost}
        disableClearable={!post.post_cod_posto}
        params={{
          wherefield: 'post_controla_20',
          valuewherefield: somente20graus === true ? 'N' : 'T',
          typewherefield: 'NEQUALS',
        }}
      />

      <TypeFilters
        ref={filterRef}
        initials={{
          tipo: 1,
          datahora_inicio: format(setSeconds(setMinutes(setHours(subDays(new Date(), 7), 0), 0), 0), 'dd/MM/yyyy HH:mm:ss'),
          datahora_fim: format(setSeconds(setMinutes(setHours(new Date(), 23), 59), 59), 'dd/MM/yyyy HH:mm:ss')
        }}
        name="filtroData"
        numberOfYears={9}
        options={[
          { label: t('s.geral.filtro.turno'), value: 5 },
          { label: t('s.geral.filtro.periododatahora'), value: 1 }]}
        onCallback={handleGetData}
        initialURL="/turno/getturnosinicio"
        finalURL="/turno/getturnosfim"
        code={post.post_cod_posto}
      />

      <Select
        name="corredor"
        label="Corredor"
        options={
          [{ label: 'Todos', value: 'todos' },
          { label: 'Sudeste', value: 'sudeste' }]
        }
        defaultValue="todos"
      />

      <Input name="bico" label="Bico" type="text" />
      <Input name="veiculo" label="Equipamento" type="text" />
      <Input name="maquinista" label="Maquinista" type="text" />

      <Checkbox
        name="totalizar"
        label="Totalizar" />

      <Checkbox
        name="overfill"
        label="Com Overfill"
      />

      <Select
        name="ordenacao"
        label="Ordenação"
        options={
          [{ label: 'Listagem', value: 'listagem' },
          { label: 'Data', value: 'data' },
          { label: 'Bico', value: 'bico' },
          { label: 'Posto', value: 'posto' },
          { label: 'Equipamento', value: 'equipamento' }]
        }
        defaultValue="listagem"
      />

      <Select
        name="ident"
        label="Identificação"
        options={
          [{ label: 'Todos', value: 'todos' },
          { label: 'A2vf', value: 'a2vf' },
          { label: 'Auto', value: 'auto' },
          { label: 'Manual', value: 'manual' }]
        }

        defaultValue="todos"
      />


      <RadioGroup
        name="tipo"
        label="Formato de saída:"
        options={[
          { label: 'PDF', value: 'pdf' },
          { label: 'Excel', value: 'xls' },
        ]}
        defaultValue="pdf"
        serialize={(value) => value}
        row
      />

    </Report>
  )
}
